import { CameraIcon, PhotoIcon, PlusIcon } from "@heroicons/react/24/solid";
import React, { useContext, useRef, useState } from "react";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";

const Stories = () => {
  const [stories, setStories] = useState(portfolioConfig.stories);
  const [activeStory, setActiveStory] = useState(null);
  const fileInputRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const { darkMode } = useContext(ThemeContext);

  const openStory = (story) => {
    setActiveStory(story);
    setStories(
      stories.map((s) => (s.id === story.id ? { ...s, viewed: true } : s))
    );
    setTimeout(() => setActiveStory(null), 5000); // Auto-close after 5 seconds
  };

  const addNewStory = async (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newStory = {
          id: stories.length + 1,
          title: "You",
          image: e.target.result,
          viewed: false,
        };
        setStories([newStory, ...stories]);
      };
      reader.readAsDataURL(file);
    }
    setShowOptions(false);
  };

  const handleFilePicker = (event) => {
    const file = event.target.files[0];
    if (file) {
      addNewStory(file);
    }
  };

  const handleCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const videoElement = document.createElement("video");
      videoElement.srcObject = stream;
      videoElement.play();

      setTimeout(() => {
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        canvas.getContext("2d").drawImage(videoElement, 0, 0);
        stream.getTracks().forEach((track) => track.stop());

        canvas.toBlob((blob) => {
          const file = new File([blob], "camera_photo.jpg", {
            type: "image/jpeg",
          });
          addNewStory(file);
        }, "image/jpeg");
      }, 1000); // Wait for 1 second to allow camera to initialize
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  return (
    <div className="mb-8">
      <div className="flex p-4 space-x-4 overflow-x-auto scrollbar-none">
        <div className="flex flex-col items-center">
          <div
            className={`flex items-center justify-center w-16 h-16 rounded-full cursor-pointer  ${
              !darkMode ? "bg-gray-200" : "bg-gray-800"
            }`}
            onClick={() => setShowOptions(!showOptions)}
          >
            <PlusIcon className="w-8 h-8 text-gray-500" />
          </div>
          <span className="mt-1 text-xs">Add Story</span>
          {showOptions && (
            <div
              className={`absolute p-2 mt-20  rounded-lg shadow-lg ${
                !darkMode ? "bg-white" : "bg-gray-800"
              }`}
            >
              <button
                className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-900"
                onClick={() => fileInputRef.current.click()}
              >
                <PhotoIcon className="w-5 h-5 mr-2" />
                Choose Photo
              </button>
              <button
                className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-900"
                onClick={handleCamera}
              >
                <CameraIcon className="w-5 h-5 mr-2" />
                Take Photo
              </button>
            </div>
          )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFilePicker}
            accept="image/*"
            className="hidden"
          />
        </div>
        {stories.map((story) => (
          <div
            key={story.id}
            className="flex flex-col items-center cursor-pointer "
            onClick={() => openStory(story)}
          >
            <div
              className={`w-16 h-16 rounded-full ${
                story.viewed
                  ? "ring-gray-300"
                  : "ring-gradient-to-tr from-yellow-400 to-pink-500"
              } ring-2 p-1`}
            >
              <img
                src={story.image}
                alt={story.title}
                className="object-cover w-full h-full rounded-full"
              />
            </div>
            <span className="mt-1 text-xs">{story.title}</span>
          </div>
        ))}
      </div>

      {activeStory && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="relative w-full max-w-lg">
            <img
              src={activeStory.image}
              alt={activeStory.title}
              className="w-full h-auto"
            />
            <button
              className="absolute text-xl text-white top-4 right-4"
              onClick={() => setActiveStory(null)}
            >
              &times;
            </button>
            <div className="absolute text-white bottom-4 left-4">
              <p className="font-bold">{activeStory.title}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stories;
